import React from 'react';

const DashboardFooter = () => {
  return (
    <footer className="dashboard-footer">
      <div className="dashboard-footer__content">
        <p className="dashboard-footer__copyright">
          Copyright © ООО "Лагом Лайф" 2025
        </p>
      </div>
    </footer>
  );
};

export default DashboardFooter; 